<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div class="space-y-12">
            <div class="grid grid-cols-12 gap-4">
                <SimpleStatCard
                    class="col-span-12 md:col-span-4"
                    title="Meeting Today"
                    :value="meetingStats?.meetingTodayCount"
                />
                <SimpleStatCard
                    class="col-span-12 md:col-span-4"
                    title="Meeting this Week"
                    :value="meetingStats?.meetingThisWeekCount"
                />
                <SimpleStatCard
                    class="col-span-12 md:col-span-4"
                    title="Meetings this Month"
                    :value="meetingStats?.meetingThisMonthCount"
                />
            </div>
            <div class="space-y-4">
                <div class="font-bold text-xl lg:text-2xl">
                    View my Booking Page
                </div>
                <div class="flex items-center gap-2">
                    <Button
                        as="a"
                        target="_blank"
                        :href="
                            urlFactory.makeCompanyBookingFormUrl(
                                authCompany.slug,
                            )
                        "
                        color="primary"
                        iconName="external-link"
                        iconClass="w-3.5 h-3.5"
                        :iconRight="true"
                    >
                        View
                    </Button>
                    <ShareLinkButtonModal
                        :shareUrl="
                            urlFactory.makeCompanyBookingFormUrl(
                                authCompany.slug,
                            )
                        "
                        buttonSize="normal"
                        :analyticsSurface="
                            AnalyticsEventSurfaceEnum.Share_BookingPageLink_DashboardPage
                        "
                    />
                </div>
            </div>
            <div class="grid grid-cols-12">
                <div class="col-span-12 lg:col-span-6 space-y-4">
                    <div
                        class="font-bold text-xl lg:text-2xl flex items-center gap-2"
                    >
                        <span> Add to my Website </span>
                        <Badge color="success">New</Badge>
                    </div>
                    <div>
                        <EmbedButtonDesigner
                            :destinationUrls="embedDestinationUrls"
                            :company="authCompany"
                        />
                    </div>
                </div>
            </div>
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import {
        AnalyticsEventSurfaceEnum,
        type MeetingStatsType,
        type PageMeta,
    } from '@/Shared/AutoGenerated/Main'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import SimpleStatCard from '@/Shared/Component/SimpleStatCard.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ShareLinkButtonModal from '@/App/Service/Component/Service/ShareLinkButtonModal.vue'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import Badge from '@/Shared/Component/Badge.vue'
    import Service from '@/App/Service/Entity/Service'
    import type { EmbedButtonDestinationUrl } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import EmbedButtonDesigner from '@/App/Company/Component/EmbedButtonDesigner.vue'

    interface ShowDashboardProps {
        pageMeta: PageMeta
        appSharedDataData: any
        meetingStats: MeetingStatsType
        servicesData: Service[]
    }

    const props = defineProps<ShowDashboardProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const authCompany = appSharedData.getAuthCompany()

    // ----------------------------
    // Embed button
    // ----------------------------

    const localServices = Service.hydrateMultiple(props.servicesData)
    const urlFactory = new UrlFactory()

    const embedDestinationUrls: EmbedButtonDestinationUrl[] = [
        {
            title: 'Main Booking Page',
            url: urlFactory.makeCompanyBookingFormUrl(authCompany.slug),
            isDisabled: false,
        },
        ...localServices.map((service: Service) => {
            return {
                title: service.title,
                url: urlFactory.makeServiceBookingFormPageUrl(
                    authCompany.slug,
                    service.slug,
                ),
                isDisabled: !service.isEnabled,
            }
        }),
    ]
</script>
